// Adapted from https://codepen.io/ReGGae/pen/pxMJLW
function SmoothScroll() {

	var _this = this;

	_this.math = {
		lerp: function lerp(a, b, n) {
			return (1 - n) * a + n * b;
		},
		norm: function norm(value, min, max) {
			return (value - min) / (max - min);
		}
	};

	_this.config = {
		height: window.innerHeight,
		width: window.innerWidth
	};

	_this.data = {
		ease: 0.1,
		current: 0,
		last: 0
	};

	_this.dom = {
		el: document.querySelector('[data-scroll]'),
		content: document.querySelector('[data-scroll-content]')
	};

	_this.rAF = null;

	_this.bindMethods = function(){
		var __this = this;
		['scroll', 'run', 'resize'].forEach(function (fn) {
			return __this[fn] = __this[fn].bind(__this);
		});
	};

	_this.setStyles = function(){
		_this.dom.el.style.position = 'fixed';
		_this.dom.el.style.top = 0;
		_this.dom.el.style.left = 0;
		_this.dom.el.style.height = '100%';
		_this.dom.el.style.width = '100%';
		_this.dom.el.style.overflow = 'hidden';
	};

	_this.setHeight = function(){
		document.body.style.height = "".concat(_this.dom.content.offsetHeight, "px");
	};

	_this.resize = function(){
		_this.setHeight();
		_this.scroll();
	};

	_this.scroll = function(){
		_this.data.current = window.scrollY;
	};

	_this.run = function(){
		_this.data.last = _this.math.lerp(_this.data.last, _this.data.current, _this.data.ease);
		_this.data.last = Math.floor(_this.data.last * 100) / 100;

		if (_this.data.last < .1) {
			_this.data.last = 0;
		}

		var diff = _this.data.current - _this.data.last;
		var acc = diff / _this.config.width;
		var velo = +acc;
		//var skew = velo * 7.5;
		var skew = velo * 3.5;
		_this.dom.content.style.transform = "translate3d(0, -".concat(_this.data.last, "px, 0)");
		//this.dom.content.style.transform = "translate3d(0, -".concat(this.data.last, "px, 0) skewY(").concat(skew, "deg)");
		_this.requestAnimationFrame();
	};

	_this.on = function(){
		var requestAnimationFrame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
		_this.setStyles();
		_this.setHeight();
		_this.addEvents();
		requestAnimationFrame && _this.requestAnimationFrame();
	};

	_this.off = function(){
		var cancelAnimationFrame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
		cancelAnimationFrame && _this.cancelAnimationFrame();
		_this.removeEvents();
	};

	_this.requestAnimationFrame = function(_requestAnimationFrame){
		function requestAnimationFrame() {
			return _requestAnimationFrame.apply(this, arguments);
		}

		requestAnimationFrame.toString = function() {
			return _requestAnimationFrame.toString();
		};

		return requestAnimationFrame;
	}(function(){ _this.rAF = requestAnimationFrame(_this.run); });

	_this.cancelAnimationFrame = function (_cancelAnimationFrame) {
		function cancelAnimationFrame() {
			return _cancelAnimationFrame.apply(this, arguments);
		}

		cancelAnimationFrame.toString = function () {
			return _cancelAnimationFrame.toString();
		};

		return cancelAnimationFrame;
	}(function(){ _this.cancelAnimationFrame(_this.rAF); });


	_this.destroy = function(){
		document.body.style.height = '';
		_this.data = null;
		_this.removeEvents();
		_this.cancelAnimationFrame();
	};

	/*
	_this.resize = function(){
		_this.setHeight();
	};
	*/

	_this.addEvents = function(){
		window.addEventListener('resize', _this.resize, {
			passive: true
		});
		window.addEventListener('scroll', _this.scroll, {
			passive: true
		});
	};

	_this.removeEvents = function(){
		window.removeEventListener('resize', _this.resize, {
			passive: true
		});
		window.removeEventListener('scroll', _this.scroll, {
			passive: true
		});
	};

	_this.init = function(){
		_this.on();
	};


	_this.init();

}
